import React from 'react';

interface LogoProps {
  size?: number;
  className?: string;
  animated?: boolean;
}

const ReactiveStackLogo: React.FC<LogoProps> = ({ 
  size = 80, 
  className = "", 
  animated = true 
}) => {
  return (
    <div className={`inline-flex items-center justify-center ${className}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
        className={animated ? "animate-pulse-slow" : ""}
      >
        {/* Outer ring representing React's atomic structure */}
        <circle
          cx="50"
          cy="50"
          r="45"
          fill="none"
          stroke="url(#gradient1)"
          strokeWidth="2"
          opacity="0.3"
          className={animated ? "animate-spin-slow" : ""}
        />
        
        {/* Middle ring */}
        <circle
          cx="50"
          cy="50"
          r="35"
          fill="none"
          stroke="url(#gradient2)"
          strokeWidth="1.5"
          opacity="0.5"
          className={animated ? "animate-spin-slow" : ""}
          style={{
            animationDirection: animated ? 'reverse' : 'normal',
            animationDuration: '4s'
          }}
        />
        
        {/* Inner TypeScript-inspired geometric shape */}
        <polygon
          points="50,25 65,40 65,60 50,75 35,60 35,40"
          fill="url(#gradient3)"
          opacity="0.8"
        />
        
        {/* Central React atom core */}
        <circle
          cx="50"
          cy="50"
          r="8"
          fill="url(#coreGradient)"
          className={animated ? "animate-bounce-slow" : ""}
        />
        
        {/* Stack layers representing "Stack" */}
        <rect x="20" y="85" width="60" height="3" rx="1.5" fill="url(#gradient1)" opacity="0.6" />
        <rect x="22" y="89" width="56" height="3" rx="1.5" fill="url(#gradient2)" opacity="0.6" />
        <rect x="24" y="93" width="52" height="3" rx="1.5" fill="url(#gradient3)" opacity="0.6" />
        
        {/* Orbital electrons */}
        <circle cx="50" cy="20" r="3" fill="#61DAFB" className={animated ? "animate-pulse" : ""} />
        <circle cx="75" cy="50" r="3" fill="#3178C6" className={animated ? "animate-pulse" : ""} />
        <circle cx="50" cy="80" r="3" fill="#06B6D4" className={animated ? "animate-pulse" : ""} />
        <circle cx="25" cy="50" r="3" fill="#8B5CF6" className={animated ? "animate-pulse" : ""} />
        
        {/* Gradient definitions */}
        <defs>
          <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" style={{stopColor: '#61DAFB', stopOpacity: 1}} />
            <stop offset="50%" style={{stopColor: '#3178C6', stopOpacity: 1}} />
            <stop offset="100%" style={{stopColor: '#06B6D4', stopOpacity: 1}} />
          </linearGradient>
          
          <linearGradient id="gradient2" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" style={{stopColor: '#8B5CF6', stopOpacity: 1}} />
            <stop offset="50%" style={{stopColor: '#3B82F6', stopOpacity: 1}} />
            <stop offset="100%" style={{stopColor: '#06B6D4', stopOpacity: 1}} />
          </linearGradient>
          
          <linearGradient id="gradient3" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" style={{stopColor: '#3178C6', stopOpacity: 0.8}} />
            <stop offset="100%" style={{stopColor: '#1D4ED8', stopOpacity: 0.8}} />
          </linearGradient>
          
          <radialGradient id="coreGradient" cx="50%" cy="50%" r="50%">
            <stop offset="0%" style={{stopColor: '#FBBF24', stopOpacity: 1}} />
            <stop offset="100%" style={{stopColor: '#F59E0B', stopOpacity: 1}} />
          </radialGradient>
        </defs>
      </svg>
    </div>
  );
};

export default ReactiveStackLogo;